import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const postQrCodeByStatus = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qrcode-by-status',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getQrCodeForImage = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/qrcode',
    headers: getHeaders(),
  });
};

export const getGarmentInspectionByCustomer = (tagId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/order-tag/' +
      tagId +
      '/garment-inspection-by-customer',
    headers: getHeaders(),
  });
};